var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"room-app"}},[_c('iframe',{attrs:{"src":`${_vm.env.meta.VUE_APP_BASE_PRE_ROOM || ''}/room/index.html?${_vm.model}&t=1`,"frameborder":"0","width":"100%","height":"100%","id":"xunw_zxdb"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }